import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { ServiceAPI } from "../../Api/ServiceAPI";
import axios from "axios";
import * as XLSX from "xlsx";

const FishStatusBrda = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { locationName } = useParams();

  const selectedLocation = state?.selectedLocation || locationName || "";
const initialFishData = [
    { acIdent: 10107, name: "Filet sabljarke premium sashimi" },
    { acIdent: 111113, name: "Filet tune II" },
    { acIdent: 10106, name: "Filet tune premium sashimi" },
    { acIdent: 10003, name: "Lignja j.a.r." },
    { acIdent: 10805, name: "List smrznuti 400-500g" },
    { acIdent: 20020, name: "Losos - Salmon salar SAL" },
    { acIdent: 20043, name: "Losos filet svjezi" },
    { acIdent: 111112, name: "Lubin filet" },
    { acIdent: 20001, name: "Lubin I (200-300g) Dicentrarchus labrax BSS" },
    { acIdent: 20003, name: "Lubin L (300-400g) Dicentrarchus labrax BSS" },
    { acIdent: 20004, name: "Lubin LL (400-600g) Dicentrarchus labrax BSS" },
    { acIdent: 20005, name: "Lubin LLL (600-800g) Dicentrarchus labrax BSS" },
    { acIdent: 30062, name: "Mol 1 - Merluccius merluccius HKE" },
    { acIdent: 30063, name: "Mol 2 - Merluccius merluccius HKE" },
    { acIdent: 30064, name: "Mol 3 - Merluccius merluccius HKE" },
    { acIdent: 30129, name: "Mol fete" },
    { acIdent: 30129, name: "Mol filet svj." },
    { acIdent: 111111, name: "Orada filet" },
    { acIdent: 20010, name: "Orada L (300-400g) Sparus aurata SBG" },
    { acIdent: 20011, name: "Orada LL (400-600g) Sparus aurata SBG" },
    { acIdent: 30142, name: "Romb cijeli (1000-1500 g/kom)" },
    { acIdent: 111114, name: "Romb smrznuti" },
    { acIdent: 10013, name: "Sipa smrznuta" },
    { acIdent: 30188, name: "Srdela BG (bez glave/očišćena) 300g MAP" },
    { acIdent: 30189, name: "Srdela Filet 200g MAP" },
    { acIdent: 30101, name: "Trlja 2 - Mullus barbatus MUT" },
    { acIdent: 30128, name: "Trlja filet svj." },
    { acIdent: 30128, name: "Trlja očišćena" },
    { acIdent: 10811, name: "Škamp seafrozen 25/1" },
    { acIdent: 10021, name: "Škamp stp 21-25" }
];
const [fishData, setFishData] = useState(() => {
  try {
    const storedData = localStorage.getItem(
      `fishData_${selectedLocation}_lastVersion`
    );
    const parsedStored = storedData ? JSON.parse(storedData) : [];

    const storedMap = new Map(
      parsedStored.map((item) => [item.acIdent, item])
    );

    const mergedData = initialFishData.map((fish) => {
      const storedFish = storedMap.get(fish.acIdent);
      return {
        ...fish,
        stanje: storedFish?.stanje || "",
        otpis: storedFish?.otpis || "",
      };
    });

    return mergedData;
  } catch (error) {
    console.error("Failed to parse or merge fish data:", error);
    return initialFishData;
  }
});


  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);
  const [saveSuccess, setSaveSuccess] = useState(false);

  const today = new Date();
  const formattedDate = today.toLocaleDateString("hr-HR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  const getCurrentTime = () => {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");
    return `${hours}_${minutes}_${seconds}`;
  };

  const removeDiacritics = (str) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  useEffect(() => {
    localStorage.setItem(
      `fishData_${selectedLocation}_lastVersion`,
      JSON.stringify(fishData)
    );
  }, [fishData, selectedLocation]);

  const handleInputChange = (index, field, value) => {
    const updatedFishData = [...fishData];
    const updatedErrors = { ...errors };

    const sanitizedValue = value.replace(",", ".");

    if (sanitizedValue === "") {
      updatedFishData[index][field] = "";
      delete updatedErrors[`${index}-${field}`];
    } else if (isNaN(sanitizedValue) || parseFloat(sanitizedValue) < 0) {
      updatedErrors[`${index}-${field}`] = "Unesite valjani broj (0 ili više).";
    } else {
      updatedFishData[index][field] = sanitizedValue;
      delete updatedErrors[`${index}-${field}`];
    }

    setFishData(updatedFishData);
    setErrors(updatedErrors);
  };

  const handleKeyPress = (e, index, field) => {
    const regex = /^[0-9.,]*$/;
    if (!regex.test(e.key) && e.key !== "Enter") {
      e.preventDefault();
    }
    if (e.key === "Enter") {
      e.preventDefault();

      if (field === "stanje") {
        const nextIndex = index + 1;
        if (nextIndex < fishData.length) {
          document.getElementById(`fish-stanje-${nextIndex}`)?.focus();
        } else {
          document.getElementById(`fish-otpis-0`)?.focus();
        }
      } else if (field === "otpis") {
        const nextIndex = index + 1;
        if (nextIndex < fishData.length) {
          document.getElementById(`fish-otpis-${nextIndex}`)?.focus();
        } else {
          e.target.blur();
        }
      }
    }
  };

  const handleSave = async () => {
    const newErrors = {};

    fishData.forEach((fish, index) => {
      if (!fish.stanje || fish.stanje.trim() === "") {
        newErrors[`${index}-stanje`] = "Molimo ispunite sva polja";
      }
    });

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      alert("Molimo ispunite sva polja prije spremanja.");
      return;
    }

    const updatedFishData = fishData.map((fish) => ({
      ...fish,
      otpis: fish.otpis === "" || fish.otpis === undefined ? "0" : fish.otpis,
    }));
    setFishData(updatedFishData);

    setSaving(true);
    setSaveSuccess(false);

    try {
      await Promise.all([
        generatePDF(updatedFishData),
        generateExcel(updatedFishData),
      ]);
      setSaveSuccess(true);
      localStorage.removeItem(`fishData_${selectedLocation}_lastVersion`);
    } catch (error) {
      console.error("One or more uploads failed:", error);
      alert("Došlo je do greške prilikom spremanja datoteka.");
    } finally {
      setSaving(false);
      setTimeout(() => {
        setSaveSuccess(false);
      }, 4000);
    }
  };

  const generatePDF = (data) => {
    const sortedData = [...data].sort((a, b) => {
      const aStanje = parseFloat(a.stanje) || 0;
      const bStanje = parseFloat(b.stanje) || 0;
      return bStanje - aStanje;
    });

    const totalStanje = sortedData.reduce(
      (sum, fish) => sum + (parseFloat(fish.stanje) || 0),
      0
    );
    const totalOtpis = sortedData.reduce(
      (sum, fish) => sum + (parseFloat(fish.otpis) || 0),
      0
    );

    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const margin = 14;

    doc.setFontSize(24);
    doc.setTextColor("#000000");
    doc.text(`LOCATION: ${selectedLocation.toUpperCase()}`, margin, 30);

    doc.setFontSize(14);
    doc.text(`Date: ${formattedDate}. Time: ${getCurrentTime()}`, margin, 38);

    doc.setFontSize(15);
    doc.setTextColor("#2E86C1");
    doc.text("Fish Data Report", margin, 20);

    doc.setDrawColor(150);
    doc.line(margin, 42, 200, 42);

    const tableData = sortedData.map((fish) => [
      fish.acIdent,
      removeDiacritics(fish.name),
      fish.stanje || "0",
      fish.otpis || "0",
    ]);

    autoTable(doc, {
      startY: 50,
      head: [["AC IDENT", "NAZIV RIBE", "STANJE (kg)", "OTPIS (kg)"]],
      body: tableData,
      headStyles: { fillColor: "#2E86C1", textColor: "#ffffff", halign: "center" },
      bodyStyles: { fillColor: "#F9F9F9", textColor: "#000000" },
      alternateRowStyles: { fillColor: "#D6EAF8" },
      columnStyles: {
        0: { cellWidth: 25 },
        1: { cellWidth: 80 },
        2: { cellWidth: 30, halign: "center" },
        3: { cellWidth: 30, halign: "center" },
      },
      styles: { fontSize: 10, halign: "left" },
      margin: { top: 50, left: margin, right: margin },
    });

    autoTable(doc, {
      startY: 5,
      margin: { left: pageWidth - 90 },
      head: [["Lokacija", selectedLocation.toUpperCase()]],
      body: [
        ["Kumulativno stanje (kg)", totalStanje.toFixed(2)],
        ["Kumulativni otpis (kg)", totalOtpis.toFixed(2)],
      ],
      theme: "grid",
      headStyles: {
        fillColor: "#4a70b3",
        textColor: "#ffffff",
        halign: "center",
        lineColor: "#000000",
        lineWidth: 0.5
      },
      bodyStyles: {
        halign: "center",
        lineColor: "#000000",
        lineWidth: 0.5
      },
      styles: {
        fontSize: 12,
        cellPadding: 3,
        lineColor: "#000000",
        lineWidth: 0.5
      },
      tableWidth: 80,
    });

    const pdfFile = doc.output("blob");
    const fileName = `fish_data_report_${selectedLocation}_${formattedDate.replaceAll(
      "/",
      "-"
    )}_time_${getCurrentTime()}.pdf`;

    return uploadToCloud(pdfFile, fileName, "application/pdf");
  };

  const generateExcel = (data) => {
    const wsData = [
      ["AC IDENT", "NAZIV RIBE", "STANJE (kg)", "OTPIS (kg)", "Location"],
    ];

    data.forEach((fish) => {
      const stanjeValue =
        fish.stanje !== undefined && fish.stanje !== ""
          ? parseFloat(fish.stanje) === 0
            ? "0"
            : fish.stanje
          : "N/A";
      const otpisValue =
        fish.otpis !== undefined && fish.otpis !== ""
          ? parseFloat(fish.otpis) === 0
            ? "0"
            : fish.otpis
          : "0";

      wsData.push([
        fish.acIdent,
        removeDiacritics(fish.name),
        stanjeValue,
        otpisValue,
        selectedLocation,
      ]);
    });

    const ws = XLSX.utils.aoa_to_sheet(wsData);

    const wsCols = [
      { wch: 10 },
      { wch: 30 },
      { wch: 15 },
      { wch: 15 },
      { wch: 20 },
    ];
    ws["!cols"] = wsCols;

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "FishData");

    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([wbout], {
      type: "application/octet-stream",
    });

    const fileName = `fish_data_report_${selectedLocation}_${formattedDate.replaceAll(
      "/",
      "-"
    )}_time_${getCurrentTime()}.xlsx`;

    return uploadToCloud(blob, fileName, "application/octet-stream");
  };

  const uploadToCloud = async (fileBlob, fileName, fileType) => {
    try {
      const token =
        localStorage.getItem("token") || sessionStorage.getItem("token");
      axios.defaults.headers.common["user_authorization"] = `Bearer ${token}`;
      const accessTokenResponse = await ServiceAPI.login();
      if (accessTokenResponse.data.result === 0) {
        const _accessToken = accessTokenResponse.data.auth;
        const locationIds = [15327822780, 15546135840];

        await Promise.all(
          locationIds.map(async (locationId) => {
            await ServiceAPI.upload_file(
              _accessToken,
              locationId,
              fileBlob,
              fileName,
              (progress) => {
                console.log(`Upload progress for ${locationId}: ${progress}%`);
              }
            );
          })
        );
        return true;
      } else {
        throw new Error("Authentication failed.");
      }
    } catch (error) {
      if (error.message === "Network Error") {
        alert(
          "Imate problema s vašom internet konekcijom. Molimo pokušajte ponovno."
        );
      } else {
        console.error("Upload failed:", error);
        alert(
          "Imate problema s vašom internet konekcijom. Molimo pokušajte ponovno."
        );
      }
      throw error;
    }
  };

  const handleRetrieveLastVersion = () => {
    try {
      const storedData = localStorage.getItem(
        `fishData_${selectedLocation}_lastVersion`
      );
      if (storedData) {
        setFishData(JSON.parse(storedData));
        setErrors({});
        alert("Zadnja nespremljena verzija je učitana!");
      } else {
        alert("Nema spremljenih podataka za dohvat.");
      }
    } catch (error) {
      console.error("Failed to retrieve data from local storage:", error);
      alert("Došlo je do greške prilikom dohvaćanja podataka.");
    }
  };

  return (
    <div className="fish-status-container">
      <div className="location-date">
        <h2 className="location-title">{selectedLocation}</h2>
        <div className="date-box">{formattedDate}</div>
      </div>

      <table className="fish-table">
        <thead>
          <tr>
            <th>NAZIV RIBE</th>
            <th>STANJE (kg)</th>
            <th>OTPIS (kg)</th>
          </tr>
        </thead>
        <tbody>
          {fishData.map((fish, index) => (
            <tr key={index}>
              <td className="fish-name">{fish.name}</td>
              <td>
                <input
                  type="text"
                  id={`fish-stanje-${index}`}
                  className={`fish-input ${
                    errors[`${index}-stanje`] ? "input-error" : ""
                  }`}
                  placeholder="Unesite stanje u kilogramima"
                  value={fish.stanje || ""}
                  onChange={(e) =>
                    handleInputChange(index, "stanje", e.target.value)
                  }
                  onKeyPress={(e) => handleKeyPress(e, index, "stanje")}
                  onBlur={() => {
                    if (fishData[index].stanje === "") {
                      setErrors((prevErrors) => ({
                        ...prevErrors,
                        [`${index}-stanje`]: "Molimo ispunite sva polja",
                      }));
                    }
                  }}
                />
                {errors[`${index}-stanje`] && (
                  <span className="error-message">
                    {errors[`${index}-stanje`]}
                  </span>
                )}
              </td>
              <td>
                <input
                  type="text"
                  id={`fish-otpis-${index}`}
                  className={`fish-input ${
                    errors[`${index}-otpis`] ? "input-error" : ""
                  }`}
                  placeholder="Unesite otpis u kilogramima"
                  value={fish.otpis || ""}
                  onChange={(e) =>
                    handleInputChange(index, "otpis", e.target.value)
                  }
                  onKeyPress={(e) => handleKeyPress(e, index, "otpis")}
                  onBlur={() => {
                    if (fishData[index].otpis === "") {
                      handleInputChange(index, "otpis", "0");
                    }
                  }}
                />
                {errors[`${index}-otpis`] && (
                  <span className="error-message">
                    {errors[`${index}-otpis`]}
                  </span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {saveSuccess && (
        <div className="save-success">
          <span
            role="img"
            aria-label="check"
            style={{ color: "green", fontSize: "24px" }}
          >
            Vaša datoteka je uspješno spremljena ✅
          </span>
        </div>
      )}

      <div className="button-container">
        <button className="save-button" onClick={handleSave} disabled={saving}>
          {saving ? "Spremanje..." : "Spremi"}
        </button>

        {/* <button className="retrieve-button" onClick={handleRetrieveLastVersion}>
          Dohvati zadnju nespremljenu verziju
        </button> */}
      </div>
    </div>
  );
};

export default FishStatusBrda;
